import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Setting = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25622 21.6C7.66841 21.1068 6.23039 20.1943 5.08214 18.9514C5.45159 18.4955 5.68189 17.9353 5.74358 17.3425C5.80527 16.7497 5.69554 16.1512 5.42843 15.6236C5.16133 15.0961 4.749 14.6634 4.2442 14.381C3.7394 14.0986 3.1651 13.9794 2.59478 14.0385C2.46486 13.3764 2.39956 12.7023 2.3999 12.0265C2.3999 10.9828 2.5535 9.97607 2.83958 9.03025H2.8799C3.36939 9.03042 3.85083 8.90078 4.27878 8.6536C4.70673 8.40641 5.06707 8.04983 5.32576 7.61751C5.58445 7.1852 5.73296 6.69143 5.75727 6.18281C5.78158 5.6742 5.68089 5.16753 5.4647 4.71065C6.59011 3.62043 7.95113 2.82792 9.43286 2.40004C9.674 2.89262 10.0414 3.30621 10.4945 3.59502C10.9475 3.88384 11.4686 4.03663 11.9999 4.03649C12.5312 4.03663 13.0523 3.88384 13.5053 3.59502C13.9584 3.30621 14.3258 2.89262 14.5669 2.40004C16.0487 2.82792 17.4097 3.62043 18.5351 4.71065C18.3173 5.17073 18.2167 5.68126 18.2429 6.19338C18.2691 6.70549 18.4211 7.20204 18.6846 7.63551C18.948 8.06897 19.3139 8.42484 19.7474 8.66905C20.1809 8.91325 20.6673 9.03762 21.1602 9.03025C21.4525 9.9999 21.6008 11.0103 21.5999 12.0265C21.5999 12.7156 21.5327 13.3888 21.405 14.039C20.8347 13.9799 20.2604 14.0991 19.7556 14.3815C19.2508 14.6639 18.8385 15.0966 18.5714 15.6241C18.3043 16.1517 18.1945 16.7502 18.2562 17.343C18.3179 17.9358 18.5482 18.496 18.9177 18.9519C17.7694 20.1946 16.3313 21.107 14.7436 21.6C14.5571 20.9954 14.191 20.4681 13.6979 20.0939C13.2048 19.7197 12.6102 19.5181 11.9999 19.5181C11.3896 19.5181 10.795 19.7197 10.3019 20.0939C9.80884 20.4681 9.44268 20.9954 9.25622 21.6Z"
        stroke={color || tailwindConfig.theme.colors.black}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 15.6C12.4727 15.6 12.9408 15.5069 13.3776 15.326C13.8143 15.1451 14.2112 14.8799 14.5455 14.5456C14.8798 14.2113 15.145 13.8145 15.3259 13.3777C15.5068 12.9409 15.5999 12.4728 15.5999 12C15.5999 11.5273 15.5068 11.0592 15.3259 10.6224C15.145 10.1856 14.8798 9.78875 14.5455 9.45446C14.2112 9.12016 13.8143 8.85499 13.3776 8.67407C12.9408 8.49316 12.4727 8.40004 11.9999 8.40004C11.0451 8.40004 10.1294 8.77932 9.45432 9.45446C8.77919 10.1296 8.3999 11.0453 8.3999 12C8.3999 12.9548 8.77919 13.8705 9.45432 14.5456C10.1294 15.2208 11.0451 15.6 11.9999 15.6V15.6Z"
        stroke={color || tailwindConfig.theme.colors.black}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Setting;
